// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import Siema from 'vue2-siema'
import civiiConf from './defaultConfig'
import { actions as defaultActions } from './defaultActions'
import { mapActions } from 'vuex'

if (!window._babelPolyfill) {
    require("babel-polyfill");
}
// import * as utils from './utils/general'

if (!window._babelPolyfill) {
    require("babel-polyfill");
}

export default function(vueConf, actions) {

    function mergeConf(oldValue, newValue) {
        let newObject = Object.assign({}, oldValue)
        for (let property in newValue) {
            let propertyValue = newValue[property]
            if (!Array.isArray(newValue[property]) &&
                typeof newValue[property] === 'object' &&
                !Array.isArray(newObject[property]) &&
                typeof newObject[property] === 'object') {
                propertyValue = mergeConf(newObject[property], newValue[property])
            }
            newObject[property] = propertyValue
        }
        return newObject
    }

    if (typeof window.civiiConf === 'object' && window.civiiConf !== null) {
        window.civiiConf = mergeConf(civiiConf, window.civiiConf)
    } else {
        window.civiiConf = civiiConf
    }

    var body = document.body
    var chatContainer = document.createElement('div')
    chatContainer.setAttribute('id', 'civii-container')
    body.insertBefore(chatContainer, body.firstChild)

    actions._ = defaultActions
    Vue.prototype.$actions = actions
    Vue.prototype.$axios = axios
        // Vue.prototype.$utils = utils
    Vue.config.productionTip = false
    Vue.use(Siema)

    /* eslint-disable no-new */
    window.civii = new Vue(mergeConf({
        el: '#civii-container',
        components: { App },
        template: '<App v-if="showChat"/>',
        computed: {
            showChat() {
                return this.$store.state.showChat
            }
        },
        created() {
            this.init()
        },
        methods: {
            ...mapActions(['getCiviiStatus']),
            init() {
                if (!window.civiiConf.isAlwaysActive) {
                    this.getCiviiStatus(0)
                } else {
                    this.$store.commit('setEnable', true)
                    this.$store.dispatch('initStore')
                    this.show()
                }
            },
            addToContext(json) {
                let props = JSON.parse(json)
                let contextoApps = sessionStorage.getItem('contextoApps')
                if (contextoApps) contextoApps = JSON.parse(contextoApps)
                else contextoApps = {}
                sessionStorage.setItem('contextoApps',
                    JSON.stringify(Object.assign(contextoApps, props)))
                this.$store.commit('addToContext', props)
            },
            updateFromContextoApps() {
                this.$store.dispatch('updateFromContextoApps')
            },
            clear() {
                for (let itemKey of Object.keys(localStorage)) {
                    if (itemKey.toLocaleLowerCase().includes('civii')) {
                        localStorage.removeItem(itemKey)
                    }
                }
            },
            hide() {
                this.$store.commit('setShowChat', false)
            },
            show() {
                this.$store.commit('setShowChat', true)
            },
            close() {
                this.hide()
                this.clear()
                try {
                    if (this.$store.state.taskSch) {
                        this.$store.state.taskSch.reset()
                    }
                    this.$store.state.taskSch = null
                } catch (e) {
                    console.log(e)
                }
            },
            restart() {
                console.log('restarting civii')
                this.close();
                this.init();
            }
        }
    }, vueConf))
}


// WEBPACK FOOTER //
// ./src/init.js